module.exports = {
    ERROR: "error",
    SUCCESS: "success",
    WARNING: "warning",
    INFO: "info"
}